module.exports = __webpack_public_path__ + "img/wolf_1920.524ec6a6.png";